<template>
    <div v-if="!!showFigures">
        
        <b-row>
            <b-col cols="12">
                <app-user-figures-general
                    :figures="figures"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <app-user-figures-period
                    :figures="figures"
                />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import reportingRepository from '../../../../../../repositories/reporting.repository';
import UserFiguresGeneral from './UserFiguresGeneral';
import UserFiguresPeriod from './UserFiguresPeriod';
export default {
    name: 'pqr_user_figures',
    components: {
        appUserFiguresGeneral: UserFiguresGeneral,
        appUserFiguresPeriod: UserFiguresPeriod,
    },
    props: ['selectedUser', 'year', 'month'],
    data: () => ({
        figures: '',
        showFigures: false
    }),
    methods: {
        async loadData() {
            if(!this.selectedUser) return;

            try {
                const rr = {...reportingRepository};
                const {data} = await rr.getPqrUserFigures(this.selectedUser.id, this.year, this.month);
                this.showFigures = true;
                this.figures = data;
            } catch(err) {
                toastr.error(`Ocurrió un error al cagar los indicadores del usuario [${err.message}]`);
            }

        }
    },
    created() {
        this.$bus.$on('pqr-user-figures.load', this.loadData);
    },
    beforeDestroy() {
        this.$bus.$off('pqr-user-figures.load');
    }
}
</script>